import { render, staticRenderFns } from "./PopGoldKnowledge.vue?vue&type=template&id=e7cf1252&lang=pug"
import script from "./PopGoldKnowledge.vue?vue&type=script&lang=js"
export * from "./PopGoldKnowledge.vue?vue&type=script&lang=js"
import style0 from "./PopGoldKnowledge.vue?vue&type=style&index=0&id=e7cf1252&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports